import React from 'react'
export default function PastActualsOne({ values, className }) {
  if (!values || !Array.isArray(values) || values.length === 0) {
    return <td>-</td>; // Render a single hyphen if no data or empty array
  }

  const cells = values.map((value, index) => (
    <td className={`${className} ${!value ? "text-center" : ""}`} key={index}>{value ? value.toLocaleString("en-IN") : '-'}</td>
  ));

  return <>{cells}</>;
}